import { combineReducers } from '@reduxjs/toolkit';
import JobReducer from './reducer';
const reducer = combineReducers({
  JobReducer
});

export default reducer;